<template>
  <div class="expertHome">
    <div class="tabPage3">
      <!-- <span :class="{ spanAct: category === '1' }" @click="tabClick('1')">
        航海类</span
      >
      <span :class="{ spanAct: category === '2' }" @click="tabClick('2')"
        >技术类</span
      > -->
    </div>
    <div class="he20"></div>
    <div class="item" v-for="(item, index) in listPage3" :key="index">
      <div class="itemLeft">
        <el-image :src="item.head" fit="fill"></el-image>
      </div>
      <div class="itemRight">
        <div class="rightName">{{ item.name }}</div>
        <div class="rightTitle">{{ item.company }}</div>
        <div class="rightsynopsis">{{ item.introduction }}</div>
        <router-link
          :to="{
            path: '/h5/expert/details',
            query: { id: item.id }
          }"
          tag="div"
          class="rightMover"
        >
          了解更多 >
        </router-link>
      </div>
    </div>
    <el-pagination
      background
      layout="prev, pager, next"
      :total="pags.total"
      :page-size.sync="pags.pageSize"
      class="pageBox"
      :pager-count="5"
      @current-change="changePage"
    ></el-pagination>
  </div>
</template>

<script>
import { getExpertShowList } from "@/api/api.js";
export default {
  data() {
    return {
      pags: {
        pageNum: 1,
        pageSize: 5,
        total: 1
      },
      category: "1",
      listPage3: []
    };
  },
  mounted() {
    this.getExpertShowList();
  },
  methods: {
    tabClick(val) {
      this.pags.pageNum = 1;
      this.pags.pageSize = 5;
      this.pags.total = 1;
      this.category = val;
      this.getExpertShowList();
    },
    getExpertShowList() {
      // 专家展示
      const dataObj = {
        pageNum: this.pags.pageNum,
        pageSize: this.pags.pageSize,
        category: ""
      };
      getExpertShowList(dataObj).then(res => {
        if (res.code === 0) {
          this.listPage3 = res.data.list;
          this.pags.total = res.data.total;
        } else {
          this.$message({
            message: res.msg,
            type: "error"
          });
        }
      });
    },
    changePage(val) {
      this.pags.pageNum = val;
      this.getExpertShowList();
    }
  }
};
</script>

<style lang="less">
.expertHome {
  width: 100%;
  padding: 16px;
  box-sizing: border-box;
  .tabPage3 {
    display: flex;
    justify-content: center;
    align-items: center;
    span {
      padding: 5px 24px;
      border: 1px solid rgba(108, 45, 102, 1);
      color: #6c2c66;
      margin: 0 20px;
      cursor: pointer;
      border-radius: 4px;
      font-weight: bold;
    }
    .spanAct {
      color: #ffffff;
      background: rgba(108, 45, 102, 1);
    }
  }
  .item {
    overflow: hidden;
    margin-bottom: 40px;
    width: 100%;
    box-shadow: 0px 4px 16px 0px rgba(46, 32, 45, 0.1);
    .itemLeft {
      margin: 20px auto 0;
      width: 210px;
      height: 240px;
    }
    .itemRight {
      width: 100%;
      height: 240px;
      padding: 20px;
      box-sizing: border-box;
      .rightName {
        height: 30px;
        font-size: 18px;
        font-weight: bold;
        color: rgba(52, 52, 52, 1);
      }
      .rightTitle {
        height: 30px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(52, 52, 52, 1);
      }
      .rightsynopsis {
        height: 120px;
        font-size: 14px;
        font-family: PingFang;
        font-weight: 400;
        color: rgba(52, 52, 52, 1);
        line-height: 20px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 6;
        -webkit-box-orient: vertical;
      }
      .rightMover {
        height: 30px;
        line-height: 30px;
        text-align: right;
        font-size: 14px;
        font-weight: 400;
        color: rgba(108, 44, 102, 1);
        cursor: pointer;
      }
    }
  }
  .pageBox {
    text-align: center;
    margin: 50px auto 0;
  }
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #0f4581;
  }
}
</style>
